var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebIcn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2513 15.4167H21.0846V17.25H0.917969V15.4167H2.7513V1.66667C2.7513 1.42355 2.84788 1.19039 3.01979 1.01849C3.1917 0.846577 3.42485 0.75 3.66797 0.75H12.8346C13.0778 0.75 13.3109 0.846577 13.4828 1.01849C13.6547 1.19039 13.7513 1.42355 13.7513 1.66667V15.4167H17.418V8.08333H15.5846V6.25H18.3346C18.5777 6.25 18.8109 6.34658 18.9828 6.51849C19.1547 6.69039 19.2513 6.92355 19.2513 7.16667V15.4167ZM4.58464 2.58333V15.4167H11.918V2.58333H4.58464ZM6.41797 8.08333H10.0846V9.91667H6.41797V8.08333ZM6.41797 4.41667H10.0846V6.25H6.41797V4.41667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcn1);
export default __webpack_public_path__ + "static/media/web-icn-1.c7d326e7419517f4e9b90bbeeb4a9f91.svg";
export { ForwardRef as ReactComponent };